export default __webpack_public_path__ + "static/media/grafika.68db433c.jpg";